export default "__VITE_ASSET__BH0dEueR__"